// extracted by css-extract-rspack-plugin
export default {"visual":"FlexSuiteRiverStack-module__visual__Gx1wK","mediaFrame":"FlexSuiteRiverStack-module__mediaFrame__vF1Oh","dither":"FlexSuiteRiverStack-module__dither__U9Ew7"};